import { apiService } from "@/_services";

/**
 * Processes and retrieves historical data for relative values.
 *
 * @param {object} ctx - Context variables for managing state.
 * @param {object} params - Query parameters for the API request.
 * @returns {Promise<void>} - A promise that resolves after processing the data.
 */
export function processModel(ctx, params) {
  return apiService
    .getAll(params)
    .then(data => {
      const parsedData = JSON.parse(JSON.stringify(data));

      ctx.models = parsedData;
      ctx.variables = parsedData
        .filter(d => d.model_type === "model" && d.short_name !== null)
        .map(d => d.short_name);
      ctx.variablesId = parsedData
        .filter(d => d.model_type === "model" && d.short_name !== null)
        .map(d => d.asset);

      ctx.pickedAsset = 0;
      ctx.showLoadingModel = false;
    })
    .catch(error => {
      ctx.showLoadingModel = false;
      console.error("Error fetching model data:", error);
    });
}
